// API Base URL - korrigiert für Vercel
const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? '' // Vercel verwendet relative URLs in Production
  : 'http://localhost:3000';

// Submit Survey to Supabase (via Backend API)
export async function submitSurvey(answers, visibleQuestions, fragebogenType, sessionId, visitorNumber, panelId = null) {
  try {
    console.log('Submitting survey to Supabase...', {
      answersCount: Object.keys(answers).length,
      questionsCount: visibleQuestions.length,
      fragebogenType,
      sessionId: sessionId?.substring(0, 8) + '...',
      visitorNumber,
      panelId: panelId ? panelId.substring(0, 8) + '...' : 'none'
    });
    
    const response = await fetch(`${API_BASE_URL}/api/submit-survey`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        answers,
        visibleQuestions,
        fragebogenType,
        sessionId,
        visitorNumber,
        panelId // NEU: Panel-ID für Backend
      }),
    });

    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.message || `HTTP Error: ${response.status}`);
    }

    console.log('Survey submitted successfully to Supabase:', result);
    return result;

  } catch (error) {
    console.error('Survey submission failed:', error);
    
    // Rethrow mit zusätzlichen Infos
    const enhancedError = new Error(error.message);
    enhancedError.originalError = error;
    enhancedError.timestamp = new Date().toISOString();
    
    throw enhancedError;
  }
}

// Submit Partial Survey (bei Screenout) - speichert alle bisherigen Antworten
export async function submitPartialSurvey(answers, visibleQuestions, fragebogenType, sessionId, visitorNumber, panelId = null) {
  try {
    console.log('=== PARTIAL SURVEY SUBMISSION ===');
    console.log('Answers:', Object.keys(answers).length, 'keys');
    console.log('Answer Keys:', Object.keys(answers));
    console.log('Visible Questions:', visibleQuestions.length);
    console.log('Session-ID:', sessionId?.substring(0, 8) + '...');
    console.log('Visitor-Number:', visitorNumber);
    console.log('Panel-ID:', panelId ? panelId.substring(0, 8) + '...' : 'none');
    
    const requestBody = {
      answers,
      visibleQuestions,
      fragebogenType,
      sessionId,
      visitorNumber,
      panelId,
      isPartialSubmission: true
    };
    
    console.log('Request Body:', JSON.stringify(requestBody, null, 2));
    
    const response = await fetch(`${API_BASE_URL}/api/submit-survey`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody),
    });

    console.log('Response Status:', response.status);
    console.log('Response OK?', response.ok);
    
    const result = await response.json();
    console.log('Response Body:', result);

    if (!response.ok) {
      console.error('❌ Partial survey submission failed:', result);
      return { success: false, error: result.message || result.error };
    }

    console.log('✅ Partial survey submitted successfully:', result);
    return { success: true, ...result };

  } catch (error) {
    console.error('❌ Partial survey submission error:', error);
    return { success: false, error: error.message };
  }
}

// Validation vor Submit
export function validateRequiredFields(answers, visibleQuestions) {
  // Definiere Pflichtfelder
  const requiredFields = [
    '1.1', // Gesundheitszustand
    '1.2', // Geschlecht  
    '1.3', // Alter
  ];

  const missing = [];
  
  for (const field of requiredFields) {
    const value = answers[field];
    
    if (!value || value === '' || (Array.isArray(value) && value.length === 0)) {
      missing.push(field);
    }
  }

  return missing;
}

// Check ob alle sichtbaren Fragen beantwortet sind
export function checkCompleteness(answers, visibleQuestions) {
  const stats = {
    total: visibleQuestions.length,
    answered: 0,
    missing: [],
    percentage: 0
  };

  for (const question of visibleQuestions) {
    const answer = answers[question.key];
    
    // Prüfe ob Frage beantwortet ist
    const isAnswered = answer !== undefined && 
                      answer !== null && 
                      answer !== '' && 
                      !(Array.isArray(answer) && answer.length === 0) &&
                      !(typeof answer === 'object' && !answer.text && !answer.audio);

    if (isAnswered) {
      stats.answered++;
    } else {
      stats.missing.push({
        key: question.key,
        text: question.text,
        type: question.type
      });
    }
  }

  stats.percentage = Math.round((stats.answered / stats.total) * 100);
  
  return stats;
}

// Submit mit Validation (angepasst für Supabase)
export async function submitSurveyWithValidation(
  answers, 
  visibleQuestions, 
  fragebogenType,
  sessionId,
  visitorNumber,
  panelId = null // NEU: Panel-ID Parameter
) {
  try {
    // 1. Validiere Pflichtfelder
    const missingRequired = validateRequiredFields(answers, visibleQuestions);
    if (missingRequired.length > 0) {
      throw new Error(`Pflichtfelder fehlen: ${missingRequired.join(', ')}`);
    }

    // 2. Prüfe Vollständigkeit
    const completeness = checkCompleteness(answers, visibleQuestions);
    console.log('Survey completeness:', completeness);

    // Optional: Warnung bei geringer Vollständigkeit
    if (completeness.percentage < 50) {
      console.warn('Survey less than 50% complete');
    }

    // 3. Submit zu Supabase (Transform passiert im Backend)
    const result = await submitSurvey(
      answers,
      visibleQuestions,
      fragebogenType,
      sessionId,
      visitorNumber,
      panelId // NEU: Panel-ID weitergeben
    );

    return {
      success: true,
      result,
      completeness,
      submissionId: result.submissionId
    };

  } catch (error) {
    return {
      success: false,
      error: error.message,
      completeness: checkCompleteness(answers, visibleQuestions)
    };
  }
}